import React from 'react';
import PropTypes from 'prop-types';

import { testId } from 'ui-components/services/testid-service';

import ConfirmationOption from './confirmation';
import DriverTipWithLabel from '../../../fulfillment-planner/local-delivery/driver-tip/with-label';
import Error from '../../../fulfillment-planner/error';
import Package from './package';
import PickupWithLabel from '../../../fulfillment-planner/local-delivery/pickup/with-label';
import Presets from '../../../fulfillment-planner/presets/container';
import RateAndCreateLabel from '../../../fulfillment-planner/rate-and-create-label';
import ShipFrom from './ship-from';
import ShippingService from './shipping-service';
import Weight from '../../../fulfillment-planner/weight/weight';

import { CUSTOMERS_CREATE_LABEL } from '../../../enums/csw-types';
import style from './style.module.less';

const sizeAndWeightClassNames = {
  'size-input': style['size-input'],
  'weight-input': style['weight-input'],
  container: style['size-and-weight-container'],
  label: style.label,
  scale: style.scale,
  weight: style.weight,
};

const RateCalcFulfillmentConfiguration = ({ fulfillmentPlanId, isQuickshipCompatible = false }) => (
  <div {...testId('csw')}>
    {fulfillmentPlanId === CUSTOMERS_CREATE_LABEL && (
      <div className={style['create-label-content-presets']}>
        <Presets fulfillmentPlanId={fulfillmentPlanId} />
      </div>
    )}
    <div className={style['rate-calculator-fulfillment-configuration']}>
      <ShipFrom fulfillmentPlanId={fulfillmentPlanId} />
      <Weight classNames={sizeAndWeightClassNames} showScale shrinkable />
      <ShippingService fulfillmentPlanId={fulfillmentPlanId} />
      <PickupWithLabel fulfillmentPlanId={fulfillmentPlanId} />
      <Package fulfillmentPlanId={fulfillmentPlanId} />
      <ConfirmationOption fulfillmentPlanId={fulfillmentPlanId} />
      <DriverTipWithLabel fulfillmentPlanId={fulfillmentPlanId} />
      <Error className={style['error-container']} />
    </div>
    <RateAndCreateLabel fulfillmentPlanId={fulfillmentPlanId} isQuickshipCompatible={isQuickshipCompatible} />
  </div>
);

RateCalcFulfillmentConfiguration.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
  isQuickshipCompatible: PropTypes.bool,
};

export default RateCalcFulfillmentConfiguration;
